import angular from "angular";

angular
    .module('mobiusControl.mobiusError', [])
    .service('MobiusError', ['$http', function ($http) {

        function uri(id, path) {
            let link = '/control-panel/mobius/errors';
            if (id) {
                link += '/' + id;
            }
            if (path) {
                link += '/' + path;
            }
            return link;
        }

        this.getList = function (params) {
            return $http.get(uri(null, 'get-list'), {params: params});
        };

    }]);

export default 'mobiusControl.mobiusError';


// WEBPACK FOOTER //
// ./resources/assets/modules/mobius-control/mobius-error.js